<form *ngIf="invoiceForm" [formGroup]="invoiceForm">
  <!-- Line first -->
  <div fxLayoutGap="20px" fxLayout="row wrap" fxLayoutAlign="start">
    <mat-form-field color="accent" appearance="outline">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.invoice-number' | translate }}</mat-label>
      <input matInput autocomplete="off" required formControlName="invoiceNumber" trimInput maxlength="20" />
    </mat-form-field>

    <mat-form-field (click)="emissionDate.open()" color="accent" appearance="outline">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.emission-date' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="emissionDate"
        required
        [readonly]="disabledFieldsByDue"
        formControlName="emissionDate"
        [placeholder]="'easy-trade.new-trade.stepper.invoice_information.emission-date-placeholder' | translate"
      />
      <mat-datepicker-toggle matSuffix [for]="emissionDate"></mat-datepicker-toggle>
      <mat-datepicker #emissionDate [disabled]="disabledFieldsByDue"></mat-datepicker>
    </mat-form-field>

    <mat-select-country
      (onCountrySelected)="onCountrySelected($event)"
      fxFlex.lt-md="100"
      [countries]="predefinedCountries"
      [required]="true"
      appearance="outline"
      readonly
      [placeHolder]="'easy-trade.new-trade.stepper.invoice_information.origin-country' | translate"
      [label]="'easy-trade.new-trade.stepper.invoice_information.origin-country' | translate"
      [formControl]="invoiceForm.controls['originCountry']"
    ></mat-select-country>

    <mat-form-field color="accent" appearance="outline">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.certificate-language' | translate }}</mat-label>

      <mat-select [formControl]="invoiceForm.controls['certificateLanguage']" required>
        <mat-option [value]="defaultValue?.certificateLanguage" *ngIf="defaultValue && !readonlyFields">
          {{ defaultValue?.certificateLanguage?.name | dashIfNull }}
        </mat-option>
        <mat-option [value]="language" *ngFor="let language of languages">
          {{ language?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex="auto" color="accent" appearance="outline">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.certificate-email' | translate }}</mat-label>
      <input matInput autocomplete="off" required formControlName="certificateEmail" type="email" />
    </mat-form-field>
  </div>

  <!-- Second line -->
  <div fxLayoutGap="20px" class="w100" fxLayout="row wrap" fxLayoutAlign="start start">
    <mat-form-field fxFlex="auto" color="accent" appearance="outline">
      <mat-label #inputInconter>{{ 'easy-trade.new-trade.stepper.invoice_information.incoterm' | translate }}</mat-label>
      <mat-select formControlName="incoterm" required *ngIf="!isReviewStep">
        <mat-option *ngIf="defaultValue && !readonlyFields" [value]="defaultValue?.incoterm">
          {{ defaultValue?.incoterm?.toUpperCase() }}
        </mat-option>

        <mat-option *ngFor="let incoterm of incoterms" [value]="incoterm">
          {{ incoterm.toUpperCase() }}
        </mat-option>
      </mat-select>

      <input matInput autocomplete="off" *ngIf="isReviewStep" formControlName="incoterm" />
    </mat-form-field>

    <mat-form-field fxFlex="auto" color="accent" appearance="outline">
      <mat-label>{{ 'easy-trade.new-trade.stepper.product-information.form.currency' | translate }}</mat-label>
      <mat-select formControlName="globalCurrency" required>
        <mat-option *ngFor="let opt of currencyOptions" [value]="opt.value">
          {{ opt.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- <mat-form-field color="accent" appearance="outline" floatLabel="always">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.cost' | translate }} </mat-label>
      <input matInput formControlName="cost" currencyMask [options]="currencyMaskConfig" placeholder="USD 0,00" OnlyNumber="true" />
    </mat-form-field> -->

    <mat-form-field color="accent" appearance="outline" floatLabel="always">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.freight' | translate }} </mat-label>
      <input matInput formControlName="freight" currencyMask [options]="currencyMaskConfig" placeholder="USD 0,00" OnlyNumber="true" />
    </mat-form-field>
    <mat-form-field color="accent" appearance="outline" floatLabel="always">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.insurance' | translate }} </mat-label>
      <input matInput formControlName="insurance" currencyMask [options]="currencyMaskConfig" placeholder="USD 0,00" OnlyNumber="true" />
    </mat-form-field>

    <mat-form-field color="accent" appearance="outline" floatLabel="always">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.landinf_fee' | translate }} </mat-label>
      <input matInput formControlName="landinf_fee" currencyMask [options]="currencyMaskConfig" placeholder="USD 0,00" OnlyNumber="true" />
    </mat-form-field>

    <mat-form-field color="accent" appearance="outline" floatLabel="always">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.others' | translate }} </mat-label>
      <input matInput formControlName="others" currencyMask [options]="currencyMaskConfig" placeholder="USD 0,00" OnlyNumber="true" />
    </mat-form-field>
  </div>

  <!-- Third line - Observacao -->
  <div fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="start">
    <mat-form-field fxFill color="accent" appearance="outline">
      <mat-label>{{ 'easy-trade.new-trade.stepper.invoice_information.observations' | translate }}</mat-label>

      <textarea
        matInput
        cdkTextareaAutosize
        trimInput
        cdkAutosizeMaxRows="50"
        cdkAutosizeMinRows="5"
        maxlength="2870"
        (keyup)="onKeyAction($event)"
        (keydown)="onKeyAction($event)"
        formControlName="observations"
      ></textarea>
    </mat-form-field>
  </div>

  <div>
    <mat-checkbox
      class="example-margin"
      formControlName="hasCertificateBrazilianOrigin"
      required
      *ngIf="invoiceForm?.value?.originCountry?.alpha3Code == 'BRA' && !readonlyFields"
      >{{ 'easy-trade.new-trade.stepper.invoice_information.has-certificate-brazilian-origin' | translate }}</mat-checkbox
    >
  </div>
</form>
